<template>
<div class="activityDistributionDialog">
    <el-dialog @close='cancel' title="分销员" :visible.sync="dialogVisible" width="800px">
        <div class="filters">
            <div class="add">
                <el-button type="success" @click="handleExport">导出</el-button>
            </div>
            <div class="search">
                <el-input placeholder="输入分销人名称" v-model="param.key" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
        </div>
        <div class="add_goods_tabs_box">
            <el-table :data="tableData" style="width: 100%" ref="multipleTable">
                <el-table-column label="分销人" min-width="250px">
                    <template slot-scope="scope">
                        <div class="goods_item_box">
                            <img class="headerImg" v-lazy="scope.row.headimgurl" alt>
                            <div>{{scope.row.customername}}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="mobileno" label="联系电话" class-name="center" min-width="120">
                    <template slot-scope="scope">{{scope.row.mobileno?scope.row.mobileno:'-'}}</template>
                </el-table-column>
                <el-table-column prop="ordercount" label="分销订单数（个）" class-name="center" min-width="150"></el-table-column>
                <el-table-column prop="finalpaymoney" label="订单金额（元）" class-name="center" min-width="120">
                    <template slot-scope="scope">{{scope.row.finalpaymoney?'￥'+scope.row.finalpaymoney:'-'}}</template>
                </el-table-column>
                <el-table-column prop="parentusermoney" label="分销佣金（￥）" class-name="center" min-width="120">
                    <template slot-scope="scope">{{scope.row.parentusermoney?'￥'+scope.row.parentusermoney:'-'}}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page" style="margin-top: 15px; text-align: center">
            <el-pagination
                background
                @current-change="handleSizeChange"
                :current-page.sync="page.page"
                :page-size="page.pageSize"
                :pager-count="11"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {getShareCustomerDetailListByEventid, exportEventShareCustomerListByBrand} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'

export default {
    name: 'activityDistributionDialog',
    data() {
        return {
            param: {
                customerid: '',
                eventid: '',
                key: ''
            },
            page: {
                page: 1,
                pageSize: 5,
                pageCount: 0
            },
            total: 0,
            dialogVisible: false,
            tableData: []
        }
    },
    mounted() {
    },
    methods: {
        handleQuery() {
            this._getList()
        },
        openDialog(eventid) {
            this.param.eventid = eventid
            this.param.key = ''
            this.dialogVisible = true
            this._getList()
        },
        cancel() {
            this.param.key = ''
            this.page = {
                page: 1,
                pageSize: 5,
                pageCount: 0
            }
            this.selectedResult = []
            this.dialogVisible = false
        },
        handleSizeChange() {
            this._getList()
        },
        handleExport() {
            this.setLoading(true)
            exportEventShareCustomerListByBrand({
                data: Object.assign({}, this.param),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '分销员' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getShareCustomerDetailListByEventid({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.sharelist
                    this.total = data.data.pageinfo.rowCount
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading', 'setBrandBusiness'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.activityDistributionDialog {
    .el-table {
        min-height: 340px;
    }
    .goods_item_box {
        display: flex;
        align-items: center;
        height: 42px;
        box-sizing: border-box;
        .headerImg {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
    .el-table__empty-block {
        height: 340px;
        max-height: 340px;
    }
    .el-table__empty-text {
        position: relative;
        top: 80px;
    }
    .el-button{
        margin-bottom: 0;
        margin-left: 20px;
    }
}
</style>
